import React from 'react';
import './Developer.css';

export default function Developer() {
  return (
    <div className="Developer">
      <span className="developer-text">Copyright 2026 Programado por</span>
      <a
        href="https://github.com/NeyBg23"
        target="_blank"
        rel="noopener noreferrer"
        className="developer-link"
      >
        NeyBg23
      </a>
    </div>
  );
}
